import { HttpClient } from '@/javascript/data/protocols/http'
import { makeAxiosHttpClient } from '@/javascript/main/factories/http'
import { CurrentAccountHttpClientDecorator } from '@/javascript/main/decorators'

declare var _currentAccount: { id: number }

export const makeCurrentAccountHttpClientDecorator = (): HttpClient =>
  new CurrentAccountHttpClientDecorator(makeAxiosHttpClient(), _currentAccount)
